import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-sticky-bottom-btns',
  templateUrl: './sticky-bottom-btns.component.html',
  styleUrls: ['./sticky-bottom-btns.component.scss']
})
export class StickyBottomBtnsComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
